import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { apiRequest, catchErrorMessageHandler } from "../../../../infrastructure/backendService";
import apiPath from "../../../../config/apiPaths.json";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import SuccessPopup from "../../../devotee/donation/successPopup";
import ErrorPopup from "../../ErrorPopup";
import { isNil } from "lodash";
import { CommonButton } from "../../StyledComponents/StyledFields";
import { RoutingURLs } from "../../RoutingURLs";
import constants from "../../../../config/constants.json";

interface PayPalProps {
  amount: number | undefined;
  purpose: string | undefined;
  unregFormData?: any;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  payPalAddToCart?: any;
  showPayPal?: boolean;
  itemsList?: any
  setOpenPaymentDialog?: React.Dispatch<React.SetStateAction<boolean>>;
  setDialogLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  setPaymentModeLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}
declare var paypal: any;

interface originalPayload {
  bookedItemInCart: {
    id: number;
    type: string;
    dateOfPooja: Date | null;
    priestName: string;
    poojaOrHallName: string;
    deities: any[]; // or specify the type of 'deities' if known
    donationPurpose: string;
    description: string;
    amount: number;
    tangibleAmount: number;
  }[];
  totalAmount: number;
  totalTanAmount: number;
}

export const PayPalPageImplementation = (props: PayPalProps) => {
  const [donationPurposeItems, setDonationPurposeItems] = useState([]);
  const [buttonAction, setButtonAction] = useState(true);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.purposeOfDonations,
      // includeToken: true,
    })
      .then((res) => {
        setDonationPurposeItems(res.data);
      })
      .catch((err) => {
        console.log(err, "donationerrorrrrr");
      });
  }, []);

  function getAccountDescriptionByDonationId(purpose: any): string | undefined {
    return (donationPurposeItems as any[]).find((each: any) => purpose === each.accountNumber)?.accountDescription;
  }

  const getAccountNumberByDescription = (donationPurposeItems: any, description: string) => {
    for (let account of donationPurposeItems) {
      if (account.accountDescription === description) {
        return account.accountNumber;
      }
    }
    // Return null if the account description is not found
    return null;
  };

  let mappedItems: {
    donationpurposeid: number;
    amount: number;
    itemId: number
    description: string;
    modeOfPayment: number
  }[] = [];

  // Iterate over each item in bookedItemInCart
  props.payPalAddToCart?.bookedItemInCart.forEach((item: originalPayload["bookedItemInCart"][number]) => {
    // Create a new object to hold the mapped fields
    let mappedItem = {} as {
      donationpurposeid: number;
      amount: number;
      itemId: number
      description: string;
      modeOfPayment: number

    };

    // Map the dynamic fields
    mappedItem.donationpurposeid = getAccountNumberByDescription(donationPurposeItems, item.donationPurpose);
    mappedItem.amount = item.amount;
    mappedItem.itemId = item.id;
    mappedItem.description = item.description;
    mappedItem.modeOfPayment = 33
    mappedItems.push(mappedItem);
  });

  const navigate = useNavigate();

  const postData = async (unRegisteredDevoteeReqBody: any) => {
    try {
      const res = await apiRequest({
        method: "POST",
        endpoint: apiPath.payPalUnRegisteredDevoteePOSTCall,
        includeToken: true,
        body: JSON.stringify(unRegisteredDevoteeReqBody)
      });

      if (props && props.setIsOpen) {
        props.setIsOpen(false);
      }
      sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
      navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
      navigate(0);
    } catch (err) {
      console.log(err);
    }
  }

  const createOrder = (data: any, actions: any) => {
    return actions.order.create({
      intent: "CAPTURE",
      purchase_units: [
        {
          description: props.purpose ? props.purpose : "ADD_TO_CART",
          amount: {
            currency_code: "USD",
            value: props.payPalAddToCart ? props.payPalAddToCart.totalAmount : props.amount,
          }
        }
      ]
    })
  }

  const onApprove = async (data: any, actions: any) => {
    try {
      const order = await actions.order.capture();
      if (props.payPalAddToCart) {
        if (props && props.setPaymentModeLoading) {
          props.setPaymentModeLoading(true);
        }
        let payloadForAddToCart = {
          paypalDetails: {
            paypalId: order.id,
            amount: props.payPalAddToCart?.totalAmount,
            transactionDate: new Date(order.update_time).getTime()
          },
          items: mappedItems,
          modeOfPayment: 33
        };
        apiRequest({
          method: "POST",
          endpoint: apiPath.cartPayment,
          includeToken: true,
          body: JSON.stringify(payloadForAddToCart)
        })
          .then((res) => {
            if (props && props.setIsOpen) {
              props.setIsOpen(false);
            }
            if (props && props.setPaymentModeLoading) {
              props.setPaymentModeLoading(false);
            }
            sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
            navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
          })
          .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
              duration: constants.TOAST_POPUP_DURATION,
            });
          })
      }
      else if (props.itemsList) {
        if (props.setDialogLoading) {
          props.setDialogLoading(true);
        }
        let poojaReqBody = {
          paypalDetails: {
            paypalId: order.id,
            amount: props.amount?.toString(),
            transactionDate: new Date(order.update_time).getTime(),
          },
          items: [
            ...props?.itemsList?.map((id: any) => ({
              itemId: id,
              modeOfPayment: 33,
            })),
          ],
          modeOfPayment: 33,
        };
        apiRequest({
          method: "POST",
          endpoint: props.purpose === "H" ? apiPath.RequestedPoojaHallBookingPayment : apiPath.DevoteeHallBookingPaymentProcess,
          includeToken: true,
          body: JSON.stringify(poojaReqBody)
        })
          .then((res) => {
            if (props && props.setIsOpen) {
              props.setIsOpen(false);
            }
            if (props.setOpenPaymentDialog) {
              props.setOpenPaymentDialog(false);
            }
            if (props.setDialogLoading) {
              props.setDialogLoading(false);
            }
            sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
            navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
          })
          .catch((err) => {
            console.log(err)
            if (props.setOpenPaymentDialog) {
              props.setOpenPaymentDialog(false);
            }
            if (props.setDialogLoading) {
              props.setDialogLoading(false);
            }
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
              duration: constants.TOAST_POPUP_DURATION,
            });
          })

      }
      else if (!props.unregFormData) {
        let registeredDevoteeReqBody = {
          paypalDetails: {
            paypalId: order.id,
            amount: (props.amount)?.toString(),
            transactionDate: new Date(order.update_time).getTime()
          },
          items: [
            {
              donationpurposeid: props.purpose,
              amount: (props.amount)?.toString(),
              description: getAccountDescriptionByDonationId(props.purpose),
              modeOfPayment: 33
            }
          ]
        }
        apiRequest({
          method: "POST",
          endpoint: apiPath.payPalRegisteredDevoteePOSTCall,
          includeToken: true,
          body: JSON.stringify(registeredDevoteeReqBody)
        })
          .then((res) => {
            if (props && props.setIsOpen) {
              props.setIsOpen(false);
            }
            sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
            navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
          })
          .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
              duration: constants.TOAST_POPUP_DURATION,
            });
          })
      }
      else {
        let unRegisteredDevoteeReqBody = {
          unregisteredDevoteeDetails: {
            firstName: props.unregFormData.name,
            lastName: props.unregFormData.lastName,
            userAddress: props.unregFormData.address,
            city: props.unregFormData.city,
            state: props.unregFormData.state,
            zipCode: props.unregFormData.zipcode,
            country: "USA",
            email: props.unregFormData.email,
            phoneNumber: props.unregFormData.phoneNumber
          },
          paypalDetails: {
            paypalId: order.id,
            amount: (props.amount)?.toString(),
            transactionDate: new Date(order.update_time).getTime()
          },
          items: [
            {
              donationpurposeid: props.purpose,
              amount: props.amount?.toString(),
              description: getAccountDescriptionByDonationId(props.purpose),
              modeOfPayment: 33
            }
          ]
        }
        postData(unRegisteredDevoteeReqBody);
      }
    } catch (err) {
      console.log(err);
      toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
        duration: constants.TOAST_POPUP_DURATION,
      });
    }
  }

  const paypalButtonContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Initialize PayPal buttons
    if (paypalButtonContainerRef.current && !paypalButtonContainerRef.current.children.length) {

      window.paypal.Buttons({
        createOrder,
        onApprove,
        style: {
          layout: 'horizontal', // Set layout to 'horizontal' to show only the PayPal button
          fundingicons: false // Hide funding icons (including the credit card icon)
        }
      }).render(paypalButtonContainerRef.current);
    }
  }, [paypalButtonContainerRef]);

  //  if (!isNil(props?.amount) && !isNil(props.purpose)) {
  //     if (props.amount <= 0 || props.purpose === "") {
  //         alert("Please enter a valid donation details.");
  //         return; // Stop the function here
  //     }
  // }
  return (
    <>
      <div ref={paypalButtonContainerRef} style={{ marginTop: "15px", width: "250px" }} id="paypal-button-container">
        {/* {buttonAction && <CommonButton sx={{ margin: " 16px 0" }} onClick={() => {
         if (typeof props?.amount !== "undefined" && (isNaN(props.amount) || props.amount <= 0) || props.purpose === "") {
          toast.custom( <ErrorPopup showMessage="Please Enter Valid Amount" isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: 5000,
          });
        }
          else {
            paypal.Buttons({
              createOrder,
              onApprove
            }).render('#paypal-button-container');
            setButtonAction(false);
          }
        }}>Proceed</CommonButton>} */}
      </div>

    </>

  );

}